import api from '../config/api';
import { API_ENDPOINTS } from '../config/constants';

export const barterService = {
  // Create a new barter listing (multipart with images)
  create: async (data, images = []) => {
    const formData = new FormData();
    formData.append('title', data.title);
    formData.append('exchange_with', data.exchange_with);
    formData.append('description', data.description || '');
    formData.append('price', data.price);
    formData.append('condition', data.condition);
    formData.append('whatsapp_number', data.whatsapp_number || '');
    formData.append('contact_number', data.contact_number || '');
    images.forEach((img) => formData.append('images', img));

    const response = await api.post(API_ENDPOINTS.BARTER.CREATE, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Get all public listings
  list: async (params = {}) => {
    const response = await api.get(API_ENDPOINTS.BARTER.LIST, { params });
    return response.data;
  },

  // Get seller's own listings
  myListings: async () => {
    const response = await api.get(API_ENDPOINTS.BARTER.MY);
    return response.data;
  },

  // Get single barter by ID
  getById: async (id) => {
    const response = await api.get(API_ENDPOINTS.BARTER.GET(id));
    return response.data;
  },

  // Delete a barter listing
  delete: async (id) => {
    const response = await api.delete(API_ENDPOINTS.BARTER.DELETE(id));
    return response.data;
  },

  // Submit exchange request
  submitExchangeRequest: async (barterId, data, images = []) => {
    const formData = new FormData();
    formData.append('product_name', data.product_name);
    formData.append('description', data.description || '');
    formData.append('condition', data.condition);
    formData.append('expected_value', data.expected_value);
    formData.append('contact_number', data.contact_number);
    formData.append('address', data.address);
    images.forEach((img) => formData.append('images', img));

    // Debug log
    console.log('FormData being sent:', {
      product_name: data.product_name,
      condition: data.condition,
      expected_value: data.expected_value,
      contact_number: data.contact_number,
      address: data.address,
      imagesCount: images.length,
    });

    const response = await api.post(API_ENDPOINTS.BARTER.EXCHANGE_REQUEST(barterId), formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  // Get exchange requests for a barter listing (seller)
  getExchangeRequests: async (barterId) => {
    const response = await api.get(API_ENDPOINTS.BARTER.GET_REQUESTS(barterId));
    return response.data;
  },

  // Check if user has already submitted a request
  checkExistingRequest: async (barterId) => {
    const response = await api.get(API_ENDPOINTS.BARTER.MY_REQUEST(barterId));
    return response.data;
  },

  // Update exchange request status (seller)
  updateRequestStatus: async (requestId, status, seller_notes = '') => {
    const response = await api.patch(API_ENDPOINTS.BARTER.UPDATE_REQUEST_STATUS(requestId), {
      status,
      seller_notes,
    });
    return response.data;
  },

  // Delete exchange request (seller)
  deleteExchangeRequest: async (requestId) => {
    const response = await api.delete(API_ENDPOINTS.BARTER.DELETE_REQUEST(requestId));
    return response.data;
  },
};

export default barterService;
